const other = [
  {
    path: '/download',
    name: 'download',
    component: () => import(/* webpackChunkName: "download" */ '@/pages/download/index'),
    meta: {
      login: false
    }
  },
  {
    path: '/download-device',
    name: 'download-device',
    component: () => import(/* webpackChunkName: "downloaDevice" */ '@/pages/download/device'),
    meta: {
      login: false,
      titleBar: {
        title: '绑定设备',
        hasMenu: false
      }
    }
  }, {
    path: '/partner',
    name: 'partner',
    component: () => import(/* webpackChunkName: "partner" */ '@/pages/partner/index.vue'),
    meta: {
      title: '健康管理平台',
      titleBar: {
        title: '健康合伙人',
        hasMenu: true
      },
      keepAlive: []
    }
  },
  // 已经成为合伙人
  {
    path: '/is-partner',
    name: 'is-partner',
    component: () => import(/* webpackChunkName: "ispartner" */ '@/pages/partner/is-partner.vue'),
    meta: {
      title: '健康管理平台',
      // titleBar: {
      //   title: '健康合伙人',
      //   hasMenu: true
      // },
      keepAlive: []
    }
  },
  {
    path: '/app-download',
    name: 'app-download',
    component: () => import(/* webpackChunkName: "appdownload" */ '@/pages/partner/app-download.vue'),
    meta: {
      title: '健康管理平台',
      titleBar: {
        title: '健康合伙人',
        hasMenu: true
      },
      keepAlive: []
    }
  },
  {
    path: '/project-agent',
    name: 'project-agent',
    component: () => import(/* webpackChunkName: "project-agent" */ '@/pages/project-agent/home.vue'),
    meta: {
      login: true,
      title: '健康管理平台'
    }
  }
]

export default other
